<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-12 11:07:55
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-09-19 11:21:36
 * @FilePath: \smart-campus-platform-front-vue\src\views\settings\base\main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="trunk">
    <lead :pathOption="pathOption"/>
    <!-- <NavBar /> -->
    <!-- <lead :headOption="headOption"/> -->
    <main >
      <router-view />
    </main>
    <foote />
  </div>
</template>

<script>
import lead from "../../homepage/base/head.vue";
import foote from '../../homepage/base/foot.vue';
import NavBar from '../../homepage/base/navbar.vue';
export default {
  components: {
    lead, foote,NavBar
  },
  data() {
    return {
      // 顶部模块标题：
      headOption: {
        link: "/setting",
        title: this.$t('modules.settings')
      },
      pathOption: {
        personal: "",//个人中心跳转路径
        manage: "",//后台跳转路径
        notSetting: true
      },
    }
  },
  mounted() {
    this.getBaseUrl();
  },
  methods: {
    // 获取跳转路径（个人中心，后台）
    getBaseUrl() {
      let host = sessionStorage.getItem("host");
      let token = localStorage.getItem("token");
      if (token != "--") {
        this.pathOption.personal = "http://" + host + "/personal/login?token=" + token + "&protocol=http&host=" + host;
        this.pathOption.manage = "http://" + host + "/admin/login?token=" + token + "&protocol=http&host=" + host;
      } else {
        this.pathOption.personal = "http://" + host + "/personal" + "?protocol=http&host=" + host;
        this.pathOption.manage = "http://" + host + "/admin" + "?protocol=http&host=" + host;
      }
    },
  }
}
</script>
<style lang="scss" scoped>

.customer-main {
  background-color: #f5f7fb;
}


  @import "./../../../assets/css/setting.scss";
</style>